
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function SearchPageHeaderRT () {
    return !this.isLoading ? _createElement('span', {
        'className': 'cm_search-page_heading',
        'key': '0'
    }, '\n  Results', this.responseQuery ? ` for "${ this.responseQuery }"` : '', this.isVehicleSelected ? ` for your
  "${ window.Convermax.getVehicleString() }"` : '', '\n') : null;
}
        export const componentNames = []